import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import {
	Checkbox,
	FormControlLabel,
	FormHelperText,
	FormControl,
} from "@mui/material";

import { CustomCheckboxProps } from "./CustomCheckbox.Props";
import { checkBoxCheckedIcon, checkboxDefaultIcon } from "utility/icons";

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
	name = "",
	label,
	className,
	isDisabled,
	isChecked = false, // Required to manage checkbox selection directly from parent component, so value prop from controller component won't be used
	handleChange,
	icon,
	labelPlacement,
}) => {
	const methods = useFormContext();
	return (
		<FormControl className={className}>
			<FormControlLabel
				control={
					<Controller
						name={name}
						render={({ field: { onChange, value }, fieldState: { error } }) => (
							<Checkbox
								checked={isChecked || value || false}
								onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
									onChange(event);
									if (handleChange) {
										handleChange(event?.target.checked);
									}
								}}
								className="custom-checkbox"
								checkedIcon={icon ? icon : checkBoxCheckedIcon}
								icon={checkboxDefaultIcon}
								disabled={isDisabled}
							/>
						)}
						control={methods.control}
					/>
				}
				label={label}
				labelPlacement={labelPlacement}
				disabled={isDisabled}
			/>
			{methods.formState.errors[name] && (
				<FormHelperText error>
					{methods.formState.errors[name].message}
				</FormHelperText>
			)}
		</FormControl>
	);
};

export default CustomCheckbox;
